import React from "react";
import PropTypes from "prop-types";
import BizLocationSelector from "../component/BizLocation/BizLocationSelector";
import DispositionSelector from "../disposition/DispositionSelector";
import BizStepSelector from "../component/BizStep/BizStepSelector";

class LsdSelector extends React.Component {

  constructor(props) {
    super(props);
    this.state = {setValue: props.setValue, entity: props.defaultValue};
  }

  setLsd() {
    const {setValue} = this.state;
    const lsd = {};

    if (this.bizLocationId) {
      lsd.bizLocation = {
        id: this.bizLocationId
      };
    }

    if (this.dispositionId) {
      lsd.disposition = {id: this.dispositionId}
    }

    if (this.bizStepId) {
      lsd.bizStep = {
        id: this.bizStepId
      }
    }

    setValue && setValue(lsd);
  }

  render() {
    const {entity = {}} = this.state;
    return (
        <div>

          <BizLocationSelector defaultValue={entity && entity.bizLocation
          && entity.bizLocation.id} setValue={bizLocationId => {
            this.bizLocationId = bizLocationId;
            this.setLsd();
          }}/>

          <DispositionSelector defaultValue={entity && entity.disposition
          && entity.disposition.id} setValue={dispositionId => {
            this.dispositionId = dispositionId;
            this.setLsd();
          }}/>

          <BizStepSelector
              defaultValue={entity && entity.bizStep && entity.bizStep.id}
              setValue={bizStepId => {
                this.bizStepId = bizStepId;
                this.setLsd();
              }}/>

        </div>
    );
  }
}

LsdSelector.propTypes = {
  setValue: PropTypes.func,
  defaultValue: PropTypes.object,
  readonly: PropTypes.bool,
};

export default LsdSelector;



// WEBPACK FOOTER //
// ./src/lsd/LsdSelector.js